import { useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import IconMarkUp from "../Icon-markup";
import ThemifyCommon from "./Common/ThemifyCommon";
import { THEMIFY_ICONS } from "../../../Data/Icons";
import { Breadcrumbs } from "../../../AbstractElements";
import { Icons, ThemifyIcon } from "../../../Constant";

const ThemifyIconContainer = () => {
  const [iTag, setiTag] = useState<string | object>("");
  const [icon, setIcon] = useState<string | object>("");

  const callback = useCallback((tag: string) => {
    setiTag({iTag: '<i className= "' + tag + '"></i>',});
    setIcon({icon: "" + tag + " fa-2x",});}, []);

  return (
    <>
    <Breadcrumbs pageTitle={ThemifyIcon} parent={Icons} title={ThemifyIcon} />
      <Container fluid>
        {THEMIFY_ICONS.map((icons, index) => {
          return (
            <Row key={index}>
              <ThemifyCommon iconType={icons.datas} title={icons.tittle} parentCallback={callback} />
            </Row>
          );
        })}
      </Container>
      <IconMarkUp itag={iTag} icons={icon} />
    </>
  );
};
export default ThemifyIconContainer;
